<div class="close mat-elevation-z3" (click)="dialogRef.close()"><i class="fa fa-times "></i></div>


<mat-tab-group *ngIf="data.componentsNumber>0">
  <mat-tab  label="Componentes">


    <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">

      <div *ngFor='let form of formComponentes'>

        <div class='default-row'>

          <div class='row-item'>
            <mat-form-field>
              <input [(ngModel)]="form.name" autocomplete="off" type="text" matInput #nombre maxlength="255"
                placeholder="Nombre" required>
              <mat-hint>{{nombre.value.length}}/255</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <div class='row-item'>
            <mat-form-field>
              <input [(ngModel)]="form.specifications" autocomplete="off" type="text" matInput #especificaciones
                maxlength="255" placeholder="Especificaciones" required>
              <mat-hint>{{especificaciones.value.length}}/255</mat-hint>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

          <!-- <div class="row-item">
            <file-input [params]='fileInputComponente' (fileSave)='fileSaveComponente($event, form.index)'></file-input>
          </div> -->


        </div>

      </div>

      <button color="primary" class="button-save mat-elevation-z5 " mat-raised-button
        (click)="saveComponente('addComponentes')">Guardar</button>

    </cdk-virtual-scroll-viewport>


  </mat-tab>
</mat-tab-group>

<mat-dialog-content>
  <h2 style="text-align: center;" *ngIf='data.action =="addComponente"'>Agregar componente</h2>
  <h2 style="text-align: center;" *ngIf='data.action =="editComponente"'>Editar componente</h2>

  <form [formGroup]="componentsForm" *ngIf='data.action =="addComponente" || data.action =="editComponente"'
    (ngSubmit)="componentsForm.valid?saveComponente(componentsForm.value):errorMessage()">


    <mat-form-field>
      <input autocomplete="off" type="text" formControlName='name' matInput placeholder="Nombre" required>
    </mat-form-field>

    <mat-form-field>
      <input autocomplete="off" type="text" formControlName='specifications' matInput placeholder="Especificaciones">
    </mat-form-field>

    <!-- <div class="row-item">
      <file-input [params]='fileInputComponente' (fileSave)='fileSaveComponente($event, "fileTable")'></file-input>
    </div> -->


    <button color="primary" class="button-save mat-elevation-z5" mat-raised-button type="submit">Guardar</button>

  </form>

</mat-dialog-content>
